import React, { FunctionComponent, useEffect, useState } from 'react';
import { ArticleModel } from '../../../services/content/article/models/ArticleModel';
import { SocialIcons } from '../ArticleHeading/SocialIcons';
import { RelatedModel } from '../../../services/content/related/models/RelatedModel';
import { Tags } from './Tags';
import styles from '../../../styles/ArticleFooter.module.scss';
import { AuthorList } from './AuthorList';
import { AdBackground } from '../../Ads/AdBackground';
import { GoogleAdDesktop } from '../../Ads/GoogleAdDesktop';
import { GoogleAdMobile } from '../../Ads/GoogleAdMobile';
import { ads } from '../../../services/ads/constants';
import { RelatedNews } from '../RelatedNews/RelatedNews';
import { ContentTypes } from '../../../constants/Enums';
import { fetchLatestArticlesFromCategoryProxy } from '../../../services/content/article/http/ArticleHttp';

type Props = {
    article: ArticleModel;
    related: RelatedModel[];
};
export const ArticleFooterTemplate2: FunctionComponent<Props> = ({ article, related }) => {
    const [latestWomanBgArticles, setLatestWomanBgArticles] = useState<ArticleModel[]>([]);
    const relatedArticles: ArticleModel[] = related
        .filter((relatedItem) => relatedItem.type === ContentTypes.ARTICLE)
        .map((relatedItem: RelatedModel) => relatedItem.data as ArticleModel);

    useEffect(() => {
        fetchLatestArticlesFromCategoryProxy(`${article.category?.id}`, '4')
            .then((response) => {
                setLatestWomanBgArticles(response.articles);
            })
            .catch((e) => console.error(e));
    }, []);

    return (
        <div>
            <div className='d-flex flex-md-row flex-column align-items-start align-items-md-center py-4 justify-content-md-between'>
                <AuthorList authors={article?.authors} customAuthor={article?.customAuthor} />
                {/*Display with full width on small devices*/}
                <SocialIcons article={article} className={'w-100 d-md-none'} />
                {/*Display in auto width on none mobile devices*/}
                <SocialIcons article={article} className={'d-md-flex d-none'} />
            </div>
            <div className={`${styles.tagsContainer} pt-3 mb-2 mb-md-0 mb-lg-0`}>
                <Tags related={related} />
            </div>
            <div className='d-inline-block d-md-none d-lg-none ad-container-h600 text-center w-100'>
                <AdBackground className='sticky-ad'>
                    <GoogleAdMobile className='d-inline-block d-md-none d-lg-none' ad={ads[18]} />
                </AdBackground>
            </div>
            <div className='text-center d-none d-md-inline-block d-lg-inline-block w-100'>
                <AdBackground className='d-inline-block'>
                    <GoogleAdDesktop ad={ads[18]} />
                </AdBackground>
            </div>
            <div>
                {relatedArticles && relatedArticles.length > 0 ? (
                    <RelatedNews articles={relatedArticles} title={'Свързани новини'} backgroundColor={'#FFFFFF'} />
                ) : null}
            </div>
            <div>
                <RelatedNews
                    articles={latestWomanBgArticles}
                    title={`Последно от категорията`}
                    backgroundColor={'#FADCE473'}
                />
            </div>
        </div>
    );
};
